/*
  kw-language-switcher.js
  Cross-Domain-Sprachumschalter fuer kaufweise.
  Grund: eine Sprache pro Domain/Markt -> Shopifys nativer language_code-Selector
  bleibt leer (available_languages.size == 1). Wir bauen die Sprachliste stattdessen
  aus den hreflang-Alternates, die Shopify auf jeder Seite mit der bereits korrekt
  UEBERSETZTEN Ziel-URL ausliefert. So landet z. B. ein Belgier von fr.kaufweise.com
  per Klick auf "Nederlands" auf derselben Seite auf kaufweise.nl.

  Markup je Platzierung (Header/Footer/Mobile-Menue):
    <div class="kw-langswitch-shell" hidden>
      ... optionale sichtbare Pille (server-gerendert) ...
      <select data-kw-langswitch> ... </select>
    </div>
  Das <select> wird hier befuellt; bei < 2 Sprachen bleibt die Shell verborgen.
*/
(function () {
  'use strict';

  // Endonyme je Sprach-Subtag (Eigenbezeichnung der Sprache).
  var ENDO = {
    de: 'Deutsch', en: 'English', nl: 'Nederlands', fr: 'Français', it: 'Italiano',
    es: 'Español', pl: 'Polski', cs: 'Čeština', da: 'Dansk', el: 'Ελληνικά',
    et: 'Eesti', fi: 'Suomi', hr: 'Hrvatski', hu: 'Magyar', lt: 'Lietuvių',
    lv: 'Latviešu', bg: 'Български', ro: 'Română', sk: 'Slovenčina',
    sl: 'Slovenščina', sv: 'Svenska', nb: 'Norsk', pt: 'Português',
    lb: 'Lëtzebuergesch', ga: 'Gaeilge', mt: 'Malti'
  };

  function buildList() {
    var cur = (document.documentElement.lang || '').toLowerCase().split('-')[0];
    var links = document.querySelectorAll('link[rel="alternate"][hreflang]');
    var byLang = {};
    for (var i = 0; i < links.length; i++) {
      var hl = (links[i].getAttribute('hreflang') || '').toLowerCase();
      if (!hl || hl === 'x-default') continue;
      var parts = hl.split('-');
      var sub = parts[0];
      var region = parts[1] || '';
      if (!ENDO[sub]) continue;
      var href = links[i].href;
      // CH-Subfolder-Varianten (de-ch/fr-ch/it-ch) zugunsten der Hauptdomain weglassen.
      var isCH = region === 'ch' || /\/(de|fr|it)-ch(\/|$)/.test(href);
      var ex = byLang[sub];
      if (!ex) byLang[sub] = { sub: sub, href: href, isCH: isCH };
      else if (ex.isCH && !isCH) byLang[sub] = { sub: sub, href: href, isCH: isCH };
    }
    var list = [];
    for (var k in byLang) {
      if (!byLang.hasOwnProperty(k)) continue;
      list.push({ sub: k, label: ENDO[k], href: byLang[k].href, current: k === cur });
    }
    list.sort(function (a, b) { return a.label.localeCompare(b.label); });
    return list;
  }

  function fill(select, list) {
    select.textContent = '';
    for (var i = 0; i < list.length; i++) {
      var o = document.createElement('option');
      o.value = list[i].href;
      o.textContent = list[i].label;
      o.setAttribute('lang', list[i].sub);
      if (list[i].current) o.selected = true;
      select.appendChild(o);
    }
    if (!select.dataset.kwWired) {
      select.addEventListener('change', function () {
        var url = this.value;
        if (url) window.location.assign(url);
      });
      select.dataset.kwWired = '1';
    }
  }

  function init() {
    var list = buildList();
    var shells = document.querySelectorAll('.kw-langswitch-shell');
    for (var i = 0; i < shells.length; i++) {
      var select = shells[i].querySelector('[data-kw-langswitch]');
      if (!select) continue;
      if (list.length < 2) { shells[i].hidden = true; continue; }
      fill(select, list);
      shells[i].hidden = false;
      shells[i].removeAttribute('hidden');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
